<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h2 class="mt-5">{{ $t("KursOrganisator") }}</h2>
        <br />
        <p>{{ $t("Haben Sie Kurse & Anmeldungen im Überblick") }}</p>
        <!-- <base-material-card :title="" color="grey">
          <v-row>
            <v-col cols="12">
              <p>
                {{ $t("Haben Sie Kurse & Anmeldungen im Überblick") }}
              </p>
            </v-col>
          </v-row>
        </base-material-card> -->
      </v-col>
    </v-row>

    <v-row>
      <v-col lg="6" cols="12">
        <base-material-stats-card
          v-if="dashboardData.registrations !== undefined"
          icon="mdi-account"
          :title="$t('Anmeldungen')"
          :value="dashboardData.registrations"
          :subText="$t('insgesamt')"
          color="info"
        >
        </base-material-stats-card>
      </v-col>
      <v-col lg="6" cols="12">
        <base-material-stats-card
          v-if="dashboardData.waiting_list !== undefined"
          icon="mdi-file-document"
          :title="$t('Warteliste')"
          :value="dashboardData.waiting_list"
          :subText="$t('insgesamt')"
        >
        </base-material-stats-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { fetchData } from "./shared/services";
export default {
  name: "app-dashboard",
  data() {
    return {
      dashboardData: {}
    };
  },

  mounted() {
    fetchData().then(res => {
      this.dashboardData = res;
    });
  }
};
</script>

<style lang="scss" scoped></style>
